import React, {useEffect} from 'react';

const SuccessPage = ({state, updateState, clearSavedState}) => {

  useEffect(() => {
    clearSavedState();
    updateState({
      showFooter: false,
    });
  }, []);

  return (
    <div className={'student-signup__success'}>
      <svg width="50" height="50" viewBox="0 0 50 50" fill="none">
        <path fillRule="evenodd" clipRule="evenodd"
              d="M1.04102 25.0013C1.04102 11.7695 11.7675 1.04297 24.9993 1.04297C38.2312 1.04297 48.9577 11.7695 48.9577 25.0013C48.9577 38.2331 38.2312 48.9596 24.9993 48.9596C11.7675 48.9596 1.04102 38.2331 1.04102 25.0013ZM38.41 18.5161L21.0202 35.9059L11.5887 26.4744L14.535 23.5282L21.0202 30.0134L35.4637 15.5698L38.41 18.5161Z"
              fill="#00A889"/>
      </svg>
      <h1 className={'student-signup__title'}>Welcome aboard!</h1>
      <p className={'student-signup__description'}>Thanks for registering with GoBuyside.</p>
      <div>
        <p>
          We've saved your information and sent a confirmation email. Based on your preferences, our team will be in touch as opportunities that fit your criteria arise and to invite you to create a profile on GoBuyside at that time.
        </p>

        <p>
          Should you have any questions, please reach out to <a href="mailto:candidatesupport@gobuyside.com">candidatesupport@gobuyside.com</a> anytime.
        </p>

        <p>
          Best Regards,<br/>
          The GoBuyside Team
        </p>
      </div>
    </div>
  )
};

export default SuccessPage;
